import { render } from "./TemplateMfittBookingError.vue?vue&type=template&id=fc010c80&scoped=true"
import script from "./TemplateMfittBookingError.vue?vue&type=script&lang=js"
export * from "./TemplateMfittBookingError.vue?vue&type=script&lang=js"

import "./TemplateMfittBookingError.vue?vue&type=style&index=0&id=fc010c80&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fc010c80"

export default script